import i18n from "../../translations";

class CurrencyHelper {
  private currencies = { AUSTRALIA: "aud", UK: "gbp" };

  moneyFormatWithoutZeros(value: number, currency = "GBP", interfaceLocale = 'en-GB') {
    if (value % 1 === 0) {
      return new Intl.NumberFormat(interfaceLocale, {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(value);
    }

    return new Intl.NumberFormat(interfaceLocale, {
      style: 'currency',
      currency: currency,
      minimumFractionDigits: 2
    }).format(value);
  }

  getTaxTranslationsByCurrency = (currency?: string) => {
    if (currency?.toLowerCase() === this.currencies.AUSTRALIA) {
      return { tax: i18n.t("common:countrySpecific.aud.tax") };
    }
    if (currency?.toLowerCase() === this.currencies.UK) {
      return { tax: i18n.t("common:countrySpecific.gbp.tax") };
    }
    return { tax: i18n.t("common:countrySpecific.default.tax") };
  };
}

export default new CurrencyHelper();
